import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { styled } from "styled-components";
import { informationsRouteList, routeList } from "../App";
import { lang } from "../assets/languages/en.language";
import Header from "../components/Header.component";
import { ReadAndConfirmModal } from "../modals/ReadAndConfirm.modal";
import api from "../services/api";
import { useUserStore } from "../store/useUserStore";
import { MainContainer, RootContainer } from "../styles/Container.style";
import { Paragraph, Title } from "../styles/Text";
import { Column, Gap, Row } from "../styles/Utils";
import CynoMethodPage from "./informations/CynoMethod.page";
import DogBodyLanguagePage from "./informations/DogBodyLanguage.page";

export default function WharningMatchPage() {
  const naviagte = useNavigate();
  const [warningConfirm1, setWarningConfirm1] = useState<boolean>(false);
  const [warningConfirm2, setWarningConfirm2] = useState<boolean>(false);
  const [warning1Open, setWarning1Open] = useState<boolean>(false);
  const [warning2Open, setWarning2Open] = useState<boolean>(false);
  const {
    profile: { isWarnedMatch },
  } = useUserStore();

  const handleWarningConfirm = (
    setWarningConfirm: Dispatch<SetStateAction<boolean>>,
    setWarningOpen: Dispatch<SetStateAction<boolean>>
  ) => {
    setWarningConfirm(true);
    setWarningOpen(false);
    // window.open("/new-page", "_blank", "noopener,noreferrer");
  };

  useEffect(() => {
    if (warningConfirm1 && warningConfirm2) {
      api.updateWarningMatch();
      naviagte(routeList.chat);
    }
  }, [warningConfirm1, warningConfirm2]);

  useEffect(() => {
    if (isWarnedMatch) {
      naviagte(routeList.chat);
    }
  }, [isWarnedMatch]);

  return (
    <RootContainer>
      <Column $alignItem="center">
        <Header sloganImgSrc="/slogans/slogan-white.png" />
        <MainContainer>
          <Paragraph>{lang.warningMatchPage.text1}</Paragraph>
          <Paragraph>{lang.warningMatchPage.text2}</Paragraph>
          <Gap $height={1} />
          <Title>Make sure you’re up to date!</Title>
          <Gap $height={1} />
          {/* <LinkOvl to={informationsRouteList.theCynoMethod} target="_blank" rel="noopener noreferrer">
          </LinkOvl> */}
          <WarningPageButton $read={warningConfirm1} onClick={() => setWarning1Open(true)}>
            <div />
            <Paragraph>
              <NeutralWeightText>{lang.warningMatchPage.buttons[0].normalText}</NeutralWeightText>{" "}
              {lang.warningMatchPage.buttons[0].strongText}
            </Paragraph>
          </WarningPageButton>
          <Gap $height={1} />
          <WarningPageButton $read={warningConfirm2} onClick={() => setWarning2Open(true)}>
            <div />
            <Paragraph>
              <NeutralWeightText>{lang.warningMatchPage.buttons[1].normalText}</NeutralWeightText>{" "}
              {lang.warningMatchPage.buttons[1].strongText}
            </Paragraph>
          </WarningPageButton>
        </MainContainer>
      </Column>
      {warning1Open && (
        <ReadAndConfirmModal
          setWarningOpen={() => handleWarningConfirm(setWarningConfirm1, setWarning1Open)}
          routeName={informationsRouteList.theCynoMethod}
        >
          <CynoMethodPage />
        </ReadAndConfirmModal>
      )}
      {warning2Open && (
        <ReadAndConfirmModal
          setWarningOpen={() => handleWarningConfirm(setWarningConfirm2, setWarning2Open)}
          routeName={informationsRouteList.dogBodyLanguage}
        >
          <DogBodyLanguagePage />
        </ReadAndConfirmModal>
      )}
    </RootContainer>
  );
}

const NeutralWeightText = styled.span`
  font-weight: normal;
`;

const WarningPageButton = styled(Row)<{ $read: boolean }>`
  width: 100%;
  height: 3rem;
  background-color: ${(props) => props.theme.color.primaryDark};
  border-radius: 100px;
  align-items: center;
  padding: 0.5rem;
  div:first-of-type {
    background-color: ${(props) => (props.$read ? props.theme.color.tertiary : props.theme.color.tertiaryLight)};
    height: 100%;
    aspect-ratio: 1;
    border-radius: 100%;
  }
  > span {
    width: 100%;
    text-align: center;
    color: ${(props) => props.theme.color.tertiaryLight};
  }
`;
